/*
 * @Author: LSG
 * @Date: 2021-08-30 17:05:26
 * @LastEditors: DQL
 * @LastEditTime: 2022-06-25 10:16:09
 * @Description: file content
 */

const jbglRoutes = {
  path: 'jbgl',
  name: 'jbgl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'jbcx',
      name: 'jbcx',
      component: () =>
        import(
          /* webpackChunkName: "jbcx" */ '@/features/attendance/jbgl/list.vue'
        ),
      meta: {
        navtabTitle: '部门加班查询',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },

    {
      path: 'grjb',
      name: 'grjb',
      component: () =>
        import(
          /* webpackChunkName: "grjb" */ '@/features/attendance/jbgl/grjbcx.vue'
        ),
      meta: {
        navtabTitle: '个人加班查询',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'jbmx/:processInsId/:taskId?',
      name: 'jbmx',
      component: () =>
        import(
          /* webpackChunkName: "jbmx" */ '@/features/attendance/jbgl/view.vue'
        ),
      meta: {
        navtabTitle: '加班申请明细',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'jbsqAdd',
      name: 'jbsqAdd',
      component: () =>
        import(
          /* webpackChunkName: "jbsq" */ '@/features/attendance/jbgl/jbsq.vue'
        ),
      meta: {
        navtabTitle: '加班申请',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'jbsq/:processInsId',
      name: 'jbsq',
      component: () =>
        import(
          /* webpackChunkName: "jbsq" */ '@/features/attendance/jbgl/jbsq.vue'
        ),
      meta: {
        navtabTitle: '加班申请',
        isCache: true,
        ignoreDiff: ['openFrom'],
        menuElements: []
      }
    },
    {
      path: 'jbsqBack/:processInsId/:condition',
      name: 'jbsqBack',
      component: () =>
        import(
          /* webpackChunkName: "jbsqBack" */ '@/features/attendance/jbgl/jbsq.vue'
        ),
      meta: {
        navtabTitle: '加班申请',
        isCache: true,
        ignoreDiff: ['openFrom'],
        menuElements: []
      }
    },
    {
      path: 'jbsqSp/:processInsId/:taskId',
      name: 'JssqSp',
      component: () =>
        import(
          /* webpackChunkName: "jbsqSp" */ '@/features/attendance/jbgl/jbsqSp.vue'
        ),
      meta: {
        navtabTitle: '加班申请审批',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'jbsqSpResult/:processInsId/:taskId',
      name: 'jbsqSpResult',
      component: () =>
        import(
          /* webpackChunkName: "jbsqSp" */ '@/features/attendance/jbgl/jbsqSp.vue'
        ),
      meta: {
        navtabTitle: '加班申请审批',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default jbglRoutes;
